import CheckoutPage from "./CheckoutPage";

Vue.component("checkout-page", CheckoutPage);
